import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import RequireAuth from "layouts/auth/RequireAuth";
import { ToastContainer } from "react-toastify";

const App = () => {
  return (
    <>
    <Routes>
      <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />

      <Route path="auth/*" element={<AuthLayout />} />

      <Route
        path="admin/*"
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }
      />

      <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
    </Routes>

     <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default App;